// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__z-qa9","tab":"TabNav_tab__2G3Bl","link":"TabNav_link__OEUsK","selectedLink":"TabNav_selectedLink__AtEgh","disabled":"TabNav_disabled__wAxrp"};